/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { truncate } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasPlaceholderView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasPlaceholderView, _super);
    function CanvasPlaceholderView() {
        var _this = _super.call(this) || this;
        _this.f = null;
        _this.j = new Color();
        _this.g = 1;
        _this.a = true;
        _this.c = 0;
        _this.b = 0;
        _this.k = new Color();
        return _this;
    }
    Object.defineProperty(CanvasPlaceholderView.prototype, "l", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            this.j = a;
            this.i();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasPlaceholderView.prototype, "h", {
        get: function () {
            return this.g;
        },
        set: function (a) {
            this.a = true;
            this.g = a;
            this.i();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasPlaceholderView.prototype, "e", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
            this.i();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasPlaceholderView.prototype, "d", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            this.b = a;
            this.i();
        },
        enumerable: true,
        configurable: true
    });
    CanvasPlaceholderView.prototype.i = function () {
        var a = this.e;
        var b = this.d;
        this.k = Color.u(truncate((this.j.l * this.g)), this.j.o, this.j.n, this.j.m);
    };
    CanvasPlaceholderView.$t = markType(CanvasPlaceholderView, 'CanvasPlaceholderView');
    return CanvasPlaceholderView;
}(Base));
export { CanvasPlaceholderView };
//# sourceMappingURL=CanvasPlaceholderView.js.map
